export default __webpack_public_path__ + "static/media/LandingLogo.ad4f4e02.svg";